// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBtSbsDBcq5OxcVQM1IcN9H7dDmueZ01eg",
  authDomain: "codenec42024.firebaseapp.com",
  projectId: "codenec42024",
  // The project's real bucket. NOT codenec42024.appspot.com, which this said
  // until the Resources page became the first thing to actually use Storage:
  // that bucket has never existed here (projects created from late 2024 get a
  // .firebasestorage.app default), so every download failed with "bucket not
  // found" - a 404 from a name nobody had reason to doubt.
  storageBucket: "codenec42024.firebasestorage.app",
  messagingSenderId: "319813082245",
  appId: "1:319813082245:web:31ed021bd6dd5a111bddec"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const db = getFirestore(app);

// Cloud Storage holds the Codenec Desktop installer, which is too large to ship
// in the site build (git refuses a file that size) and is gated by
// storage.rules rather than served openly from public/.
const storage = getStorage(app);

export { auth, db, storage };